import Vue from 'vue'

const state = Vue.observable({
  isLoading: true,
  message: '',
})

export default {
  getState() {
    return state
  },
  setLoading(loading) {
    state.isLoading = loading
  },
  setMessage(message) {
    state.message = message
  },
}
